import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';

import { IoMdArrowUp } from 'react-icons/io';
import { checkIsInternalUrl, clsx } from '../../utils/utils';
import SmartLink, { SmartLinkProps } from './SmartLink';
import * as styles from './TextLink.module.scss';

export type TextLinkProps = Omit<SmartLinkProps, 'to' | 'openInNewTab'> &
  (
    | {
        styleOnly: true;
        withExternalIcon?: boolean;
        withArrowIcon?: boolean;
        to?: never;
        openInNewTab?: never;
      }
    | {
        styleOnly?: never;
        withExternalIcon?: boolean;
        withArrowIcon?: boolean;
        to: string;
        openInNewTab?: boolean;
      }
  );

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default React.forwardRef<any, TextLinkProps>(function TextLink(
  {
    openInNewTab,
    styleOnly,
    className,
    children,
    to,
    withExternalIcon = true,
    withArrowIcon,
    ...restProps
  },
  ref,
): React.ReactElement {
  if (styleOnly) {
    return (
      <span
        className={clsx(styles.link, withArrowIcon && styles.withArrowIcon, className)}
        {...restProps}
      >
        {children}
        {withExternalIcon && !withArrowIcon && <FaExternalLinkAlt className={styles.iconRight} />}
        {withArrowIcon && <IoMdArrowUp className={styles.arrowIcon} />}
      </span>
    );
  } else {
    const isLinkInternal = checkIsInternalUrl(to);

    return (
      <SmartLink
        openInNewTab={openInNewTab}
        ref={ref}
        to={to}
        className={clsx(styles.link, withArrowIcon && styles.withArrowIcon, className)}
        {...restProps}
      >
        {children}
        {!isLinkInternal && !withArrowIcon && (
          <FaExternalLinkAlt
            className={clsx(styles.iconRight, !withExternalIcon && styles.iconHidden)}
          />
        )}
        {withArrowIcon && <IoMdArrowUp className={styles.arrowIcon} />}
      </SmartLink>
    );
  }
});
